import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle } from 'lucide-react';
export function BonusSection() {
  return <section className="py-16 px-6 md:px-12 lg:px-24 bg-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy rounded-3xl p-8 md:p-12 text-cream relative overflow-hidden shadow-xl" data-id="element-14">
          {/* Decorative background element */}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-15"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-10" data-id="element-16">
            <div className="bg-gold p-6 rounded-2xl shrink-0" data-id="element-17">
              <Gift className="w-16 h-16 text-navy-dark" data-id="element-18" />
            </div>

            <div data-id="element-19">
              <div className="inline-block bg-gold/20 text-gold-light px-4 py-1 rounded-full text-sm font-bold tracking-wider mb-4 uppercase" data-id="element-20">
                Regalo Especial Incluido
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4 font-playfair" data-id="element-21">
                Checklist: "Qué borrar antes de que sea tarde"
              </h2>
              <p className="text-xl text-cream-dark mb-6" data-id="element-22">
                Una guía delicada sobre la privacidad post-mortem. Aprende qué
                aplicaciones, historiales o mensajes deberías limpiar hoy mismo
                para proteger tu privacidad y evitar incomodidades a tu familia
                en el futuro.
              </p>
              <ul className="space-y-3" data-id="element-23">
                <li className="flex items-center gap-3 text-lg" data-id="element-24">
                  <CheckCircle className="w-6 h-6 text-gold" data-id="element-25" />
                  <span data-id="element-26">Historiales de búsqueda y navegación</span>
                </li>
                <li className="flex items-center gap-3 text-lg" data-id="element-27">
                  <CheckCircle className="w-6 h-6 text-gold" data-id="element-28" />
                  <span data-id="element-29">Aplicaciones de mensajería privada</span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}